import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowLeftLongIcon, ArrowRightLongIcon } from '../../../../components/Icon';
import rou from '../../../../router';
import { i18n } from '../../../../language';
import { onKeyUpEnterOrSpace } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0.5rem 0',
  },
  back: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'auto',
    color: theme.palette.primary.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: '500',
    textDecoration: 'none',
  },
  backIcon: {
    fontSize: '1.5rem',
    padding: '0.313rem 0.25rem',
    marginRight: '0.5rem',
  },
  postMenu: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '16.62rem',
  },
  post: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  Icon: {
    color: theme.palette.primary.main,
    margin: '0 0.5rem',
  },
}));

export default function Menus({ left, right, leftId, rightId, history, type, deletedFlag, backID, leftID, rightID }) {
  const classes = useStyles();
  return (
    <div className={classes.head}>
      <Link id={backID} className={classes.back} to={rou.ehandoverRou.path}>
        <ArrowLeftIcon className={classes.backIcon} />
        {i18n.t('DUTYASSIGN_BACK')}
      </Link>
      {deletedFlag ? (
        <div />
      ) : (
        <div className={classes.postMenu}>
          <div
            id={leftID}
            className={classes.post}
            onClick={() => left && history.push(`/ehandover/detail&id=${leftId}&type=${type}`)}
            style={{ opacity: left ? '1' : '0.6' }}
            tabIndex={0}
            onKeyUp={(e) =>
              onKeyUpEnterOrSpace(e, () => left && history.push(`/ehandover/detail&id=${leftId}&type=${type}`))
            }
          >
            <ArrowLeftLongIcon className={classes.Icon} />
            {i18n.t('EHANDOVER_PREV')}
          </div>
          <div
            id={rightID}
            className={classes.post}
            onClick={() => right && history.push(`/ehandover/detail&id=${rightId}&type=${type}`)}
            style={{ opacity: right ? '1' : '0.6' }}
            tabIndex={0}
            onKeyUp={(e) =>
              onKeyUpEnterOrSpace(e, () => right && history.push(`/ehandover/detail&id=${rightId}&type=${type}`))
            }
          >
            {i18n.t('EHANDOVER_NEXT')}
            <ArrowRightLongIcon className={classes.Icon} />
          </div>
        </div>
      )}
    </div>
  );
}
